import { Route, Routes } from 'react-router-dom';
import { NotFound, TransportQueue } from '@pages';
import Protected from '@components/Protected';

function RoutesTransportQueue() {
  return (
    <Protected>
      <Routes>
        <Route index element={<TransportQueue />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}
export default RoutesTransportQueue;
